import { render, staticRenderFns } from "./ContractsDetails.vue?vue&type=template&id=3653f172&scoped=true"
import script from "./ContractsDetails.vue?vue&type=script&lang=js"
export * from "./ContractsDetails.vue?vue&type=script&lang=js"
import style0 from "./ContractsDetails.vue?vue&type=style&index=0&id=3653f172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3653f172",
  null
  
)

export default component.exports